
import { StringsMixin } from '@/mixins';
import { AthleteReportCategory } from '@/models';
import { Component, Mixins, Prop } from 'vue-property-decorator';

@Component
export default class ScoutingScoreSelectorV3 extends Mixins(StringsMixin) {
	@Prop() categories!: Array<AthleteReportCategory>;
	@Prop({ type: Boolean }) readonly;

	onChange(data: number) {
		this.$emit('change', data);
	}

}
